import { ITEM_KINDS, STATES } from '../../../constants';

export const PAGE_TITLE = 'Update Insurance';

export function InsuranceRetentionConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_INSURANCE_RETENTION, {
    url: '/update-insurance',
    params: {
      toast: null,
    },
    views: {
      '@': {
        template: `<upd-insurance-retention></upd-insurance-retention>`,
      },
    },
    scrollTop: true,
    title: PAGE_TITLE,
    titleBar: {
      title: 'Update Your Liberty Mutual Policy',
      icon: 'libertymutual',
    },
    analytics: {
      // Disable automatically sending a page event on state transition
      ignore: true,
    },
    data: {
      moveItem: {
        type: ITEM_KINDS.INSURANCE_RETENTION,
        singleton: true,
      },
    },
  });
}
